import type { Vec2 } from '../core/model/types';
import type { Viewport } from '../core/view';

/**
 * Coordinate conversion between the three spaces the stage lives in.
 *
 *  - **client**: browser viewport, what pointer events report
 *  - **stage**: pixels inside the stage element, what absolutely positioned
 *    overlays use
 *  - **document**: image pixels, what the model and the selection store
 *
 * `screen = document * zoom + pan` is the viewport contract; these are its two
 * directions, kept in one place so a sign error cannot be repeated.
 */

export function clientToStage(clientX: number, clientY: number, stage: HTMLElement): Vec2 {
  const rect = stage.getBoundingClientRect();
  return { x: clientX - rect.left, y: clientY - rect.top };
}

export function stageToDoc(point: Vec2, viewport: Viewport): Vec2 {
  return {
    x: (point.x - viewport.pan.x) / viewport.zoom,
    y: (point.y - viewport.pan.y) / viewport.zoom,
  };
}

export function docToStage(point: Vec2, viewport: Viewport): Vec2 {
  return {
    x: point.x * viewport.zoom + viewport.pan.x,
    y: point.y * viewport.zoom + viewport.pan.y,
  };
}

export function clientToDoc(
  clientX: number,
  clientY: number,
  stage: HTMLElement,
  viewport: Viewport,
): Vec2 {
  return stageToDoc(clientToStage(clientX, clientY, stage), viewport);
}
